import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["assigned", "unassigned", "autoMapped", "autoMapFailed", "assignedTab", "unassignedTab", "autoMappedTab", "autoMapFailedTab", "allTab", "submitButton", "form"]

  connect() {
    this.initializeTabs()
    this.captureOriginalValues()
    this.setupFormSubmissionHandler()
  }

  captureOriginalValues() {
    this.originalValues = new Map()
    this.formTarget.querySelectorAll("[name*=\"integration_mappings_attributes\"]").forEach(field => {
      const value = this.isCheckboxField(field, this.formTarget)
        ? (field.checked ? "1" : "0")
        : field.value
      this.originalValues.set(field.name, value)
    })
  }

  setupFormSubmissionHandler() {
    this.formTarget.addEventListener("submit", (event) => this.filterUnchangedMappings(event))
  }

  isCheckboxField(field, form) {
    return field.type === "checkbox" || (
      field.type === "hidden" && field.value === "0" &&
      form.querySelector(`input[type="checkbox"][name="${field.name}"]`)
    )
  }

  filterUnchangedMappings(event) {
    const form = event.target
    const mappingFields = form.querySelectorAll("[name*=\"integration_mappings_attributes\"]")
    const changedMappings = this.getChangedMappings(form, mappingFields)

    // Disable unchanged mapping fields
    mappingFields.forEach(field => {
      const match = field.name.match(/integration_mappings_attributes\]\[(\d+)\]/)
      if (match && !changedMappings.has(match[1])) {
        field.disabled = true
      }
    })
  }

  getChangedMappings(form, mappingFields) {
    const changedMappings = new Set()
    const mappingRegex = /integration_mappings_attributes\]\[(\d+)\]/

    mappingFields.forEach(field => {
      const originalValue = this.originalValues.get(field.name)
      const currentValue = this.isCheckboxField(field, form)
        ? (field.checked ? "1" : "0")
        : field.value

      if (currentValue !== originalValue) {
        const match = field.name.match(mappingRegex)
        if (match) changedMappings.add(match[1])
      }
    })

    return changedMappings
  }

  showAssigned() { this.showTab("assigned") }
  showUnassigned() { this.showTab("unassigned") }
  showAutoMapped() { this.showTab("autoMapped") }
  showAutoMapFailed() { this.showTab("autoMapFailed") }
  showAll() { this.showTab("all") }

  showTab(activeTab) {
    ["assigned", "unassigned", "autoMapped", "autoMapFailed"].forEach(tab => {
      const targets = this[`${tab}Targets`]
      const isVisible = activeTab === "all" || tab === activeTab
      targets.forEach(item => {
        item.classList.toggle("hidden", !isVisible)
        item.classList.toggle("tabFiltered", isVisible)
      })
    })
    window.dispatchEvent(new CustomEvent("smart_lock:apply-search"))
  }

  enableSubmitButton() {
    this.submitButtonTargets.forEach(submit => submit.disabled = false)
  }

  initializeTabs() {
    if (this.unassignedTargets.length > 0) {
      this.showUnassigned()
      this.unassignedTabTarget.classList.add("active")
    }
    else if (this.hasAutoMappedTabTarget && this.autoMappedTargets.length > 0) {
      this.showAutoMapped()
      this.autoMappedTabTarget.classList.add("active")
    }
    else if (this.hasAutoMapFailedTabTarget && this.autoMapFailedTargets.length > 0) {
      this.showAutoMapFailed()
      this.autoMapFailedTabTarget.classList.add("active")
    }
    else {
      this.showAll()
      this.allTabTarget.classList.add("active")
    }
  }
}
